import page from '../helpers/page';
import StatesSaver from '../components/statesSaver'

page(() =>{
    StatesSaver.initState();
});
